// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UrlUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";

var feature_source_key = "feature_source";

var feature_source_val = "sticky_bottom_track_live_trip";

function appendUtmParams(url) {
  var feature_source_params = {};
  feature_source_params[feature_source_key] = feature_source_val;
  if (UrlUtils$Catalyst.getSearchParams(url).length === 0) {
    return UrlUtils$Catalyst.createRequestURLfrmParams(url, "", feature_source_params);
  } else {
    return url + "&" + feature_source_key + "=" + feature_source_val;
  }
}

export {
  feature_source_key ,
  feature_source_val ,
  appendUtmParams ,
  
}
/* No side effect */
